
import { defineComponent } from 'vue'
import { faTrash, faUpload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default defineComponent({
  name: 'ProfileUploader',
  emits: ['uploaded'],
  components: {
    FontAwesomeIcon
  },
  props: {
    image: {
      type: String,
      required: false
    },
    labelPlaceholder: {
      type: String,
      default: 'Nenhum arquivo selecionado'
    },
    types: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      value: '',
      trash: faTrash,
      error: false,
      errorMessage: '',
      uploadIcon: faUpload,
      maxFileSize: 1,
      files: [
        {
          name: ''
        }
      ],
      showRemovedBtn: false
    }
  },
  computed: {
    theFileName () {
      if ((this.files.length > 0) && 'name' in this.files[0]) {
        const result = this.files[0]
        if (result.name !== '') {
          return result.name
        } else {
          return this.labelPlaceholder
        }
      }
      return this.labelPlaceholder
    }
  },
  methods: {
    resetFile () {
      this.$refs.imageUploader.value = ''
    },
    fileChangeHandler (e: Event) {
      this.errorMessage = ''
      this.error = false

      const target = e.target as HTMLInputElement

      Array.from(target.files).map((file) => {
        if (file.size > this.maxFileSize * 1024 * 1024) {
          this.error = true
          this.errorMessage = `O arquivo é maior que ${this.maxFileSize} MB`
        }
      })

      this.files = Array.from(target.files)

      if (!this.types.includes(this.files[0].type)) {
        this.error = true
        this.errorMessage = 'O arquivo enviado é inválido.'
      }
      if (!this.error) {
        this.$emit('uploaded', this.files)
      } else {
        this.$emit('error')
      }
      this.showRemovedBtn = true
    }
  }
})
